/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoAndroidIcon16Light } from './LogoAndroidIcon16Light';
import { LogoAndroidIcon16Regular } from './LogoAndroidIcon16Regular';
import { LogoAndroidIcon16Solid } from './LogoAndroidIcon16Solid';
import { LogoAndroidIcon20Light } from './LogoAndroidIcon20Light';
import { LogoAndroidIcon20Regular } from './LogoAndroidIcon20Regular';
import { LogoAndroidIcon20Solid } from './LogoAndroidIcon20Solid';
import { LogoAndroidIcon24Regular } from './LogoAndroidIcon24Regular';
import { LogoAndroidIcon24Solid } from './LogoAndroidIcon24Solid';
import { LogoAndroidIcon32Regular } from './LogoAndroidIcon32Regular';
import { LogoAndroidIcon64Regular } from './LogoAndroidIcon64Regular';
var sizes = {
    16: {
        light: LogoAndroidIcon16Light,
        regular: LogoAndroidIcon16Regular,
        solid: LogoAndroidIcon16Solid,
    },
    20: {
        light: LogoAndroidIcon20Light,
        regular: LogoAndroidIcon20Regular,
        solid: LogoAndroidIcon20Solid,
    },
    24: {
        regular: LogoAndroidIcon24Regular,
        solid: LogoAndroidIcon24Solid,
    },
    32: {
        regular: LogoAndroidIcon32Regular,
    },
    64: {
        regular: LogoAndroidIcon64Regular,
    },
};
export var LogoAndroidIcon = forwardRef('LogoAndroidIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
